/// <reference types="chrome"/>

import log from 'loglevel';
import { CONFIG } from '../config';

class ChromeExtensionManager {
  private readonly logger = log.getLogger(ChromeExtensionManager.name);

  private readonly EXTENSION_ID = CONFIG.CHROME_EXTENSION_ID; // Just the ID, chrome-extension:// prefix is handled by Chrome APIs

  private readonly EVENT_PREFIX = 'PERFECT_EXTENSION_';

  private isChromeExtensionAvailable = (): boolean => {
    // Check if we're in a Chrome extension context
    if (typeof chrome === 'undefined') {
      this.logger.debug('Not running in Chrome extension context');
      
      return false;
    }

    // Check if we're in a web page context
    if (typeof window !== 'undefined' && window.location.protocol.startsWith('http')) {
      this.logger.debug('Running in web page context, Chrome extension APIs not available');
      
      return false;
    }

    return true;
  };

  private sendMessageToExtension = (message: { type: string }): void => {
    if (!this.isChromeExtensionAvailable()) {
      // Fallback to custom event for web context
      const event = new CustomEvent(`${this.EVENT_PREFIX}${message.type}`, {
        detail: message,
      });
      window.dispatchEvent(event);
      this.logger.debug(`Dispatched ${message.type} event for extension`);
      
      return;
    }

    try {
      const port = chrome.runtime.connect(this.EXTENSION_ID);
      port.postMessage(message);
      port.disconnect();
      this.logger.debug(`Sent ${message.type} message to Chrome extension`);
    } catch (error) {
      this.logger.error(`Failed to send ${message.type} message to Chrome extension`, error);
    }
  };

  public sendLoginMessage = (): void => {
    this.sendMessageToExtension({ type: 'USER_LOGGED_IN' });
  };

  public sendLogoutMessage = (): void => {
    this.sendMessageToExtension({ type: 'USER_LOGGED_OUT' });
  };

  public openExtensionSidebar = (): void => {
    this.sendMessageToExtension({ type: 'OPEN_SIDEBAR' });
  };
}

export default new ChromeExtensionManager();
